import React, { Component } from 'react';
import ContentDisplay from '../../components/ContentDisplay';
import { connect } from 'react-redux';
import { fetchModels, getModels } from '../../modules/models';
import { getMaterials, fetchMaterials } from '../../modules/materials';
import { getScenes, fetchScenes } from '../../modules/scenes';
import PropTypes from 'prop-types';
import { getTags, fetchTags } from '../../modules/tags';
import { createJob } from '../../modules/jobs';
import { fetchProducts, getProducts } from '../../modules/productFamily';
import { setView, setSelected, getSelected } from '../../modules/explorer';
import queryString from 'query-string';

class Listing extends Component {
  state = {
    displayType: 'list',
    filterAlphabet: null,
    tag: null,
    entitystate: 'Active',
  };

  static contextTypes = {
    router: PropTypes.object,
  };

  async componentDidMount() {
    const {
      fetchModels,
      fetchMaterials,
      fetchScenes,
      fetchTags,
      fetchProducts,
    } = this.props;
    const { filterAlphabet, tag, displayType, entitystate } = this.state;
    const query = queryString.parse(window.location.search);
    const fetchQuery = {
      page: 0,
    };
    if (query.tag && query.tag !== tag) {
      query.setTag = true;
      fetchQuery.tags = query.tag;
    } else if (tag) {
      fetchQuery.tags = tag;
    }

    if (query.filterAlphabet && filterAlphabet !== query.filterAlphabet) {
      query.setLetter = true;
      fetchQuery.friendlyName = query.filterAlphabet;
    } else if (filterAlphabet) {
      fetchQuery.friendlyName = filterAlphabet;
    }
    if (query.displayType && query.displayType !== displayType) {
      query.setDisplay = true;
    }

    if (query.entitystate && query.entitystate !== entitystate) {
      fetchQuery.state = query.entitystate;
      fetchQuery.limit = 1000;
      query.setState = true;
    }

    if (query.setLetter || query.setTag || query.setDisplay || query.setState) {
      const state = this.state;
      if (query.setLetter) state.filterAlphabet = query.letter;
      if (query.setTag) state.tag = query.tag;
      this.setState({
        tag: query.tag,
        filterAlphabet: query.filterAlphabet,
        displayType: query.displayType,
        entitystate: query.entitystate,
      });
    }
    await fetchModels(fetchQuery);
    await fetchMaterials(fetchQuery);
    await fetchScenes();
    await fetchTags();
    await fetchProducts();
  }

  onPageLeave = async query => {
    const { fetchModels, fetchMaterials } = this.props;
    const { catogary } = this.props;
    if (catogary === 'models') {
      await fetchModels(query);
    } else if (catogary === 'materials') {
      await fetchMaterials(query);
    }
  };

  navTo = (id, cat) => {
    const { router } = this.context;
    const url = `/${cat}${id ? `/${id}` : ''}`;
    router.history.push(url);
  };

  onSelect = async (id, value) => {
    let {
      setView,
      catogary,
      setSelected,
      fetchModels,
      fetchMaterials,
      selected,
    } = this.props;
    if (id === 'all') {
      const { tag, filterAlphabet, entitystate } = this.state;
      const query = {
        page: 0,
        state: entitystate,
        limit: 2000,
      };
      if (tag) query.tags = tag;
      if (filterAlphabet) query.friendlyName = filterAlphabet;
      if (value) {
        if (Object.keys(selected).length === 0)
          setView({
            page: 'listview',
            catogary: catogary,
          });
        if (catogary === 'models') {
          const models = await fetchModels(query);
          selected = models;
        } else if (catogary === 'materials') {
          const materials = await fetchMaterials(query);
          selected = materials;
        }
      } else {
        selected = {};
        setView(null);
      }
    } else if (typeof id === 'object') {
      if (Object.keys(selected).length === 0)
        setView({
          page: 'listview',
          catogary: catogary,
        });
      selected = id;
      if (Object.keys(selected).length === 0) setView(null);
    } else {
      if (value) {
        if (Object.keys(selected).length === 0)
          setView({
            page: 'listview',
            catogary: catogary,
          });
        selected[id] = true;
      } else {
        delete selected[id];
        if (Object.keys(selected).length === 0) setView(null);
      }
    }
    setSelected(catogary, selected);
    this.setState({ selected });
  };

  componentWillUnmount() {}

  onAlphabetChange = data => {
    const { router } = this.context;
    const { catogary } = this.props;
    const { tag } = this.state;
    this.setState({ filterAlphabet: data });
    router.history.push(`/${catogary}?letter=${data}&tag=${tag || ''}`);
  };

  onTagChange = tag => {
    const { router } = this.context;
    const { catogary } = this.props;
    const { filterAlphabet } = this.state;
    this.setState({ filterAlphabet: tag });
    router.history.push(
      `/${catogary}?letter=${filterAlphabet || ''}&tag=${tag}`
    );
  };

  onChange = (prop, value) => {
    const { router } = this.context;
    const { catogary } = this.props;
    const state = this.state;
    delete state.selected;
    if (prop === 'tag') {
      delete state.filterAlphabet;
    } else if (prop === 'filterAlphabet') {
      delete state.tag;
    }
    state[prop] = value;
    router.history.push(`/${catogary}?${queryString.stringify(state)}`);
  };

  render() {
    const {
      models,
      scenes,
      materials,
      catogary,
      tags,
      products,
      createJob,
      selected,
    } = this.props;
    const { filterAlphabet, displayType, tag, entitystate } = this.state;
    return (
      <ContentDisplay
        navTo={this.navTo}
        catogary={[catogary]}
        models={models}
        scenes={scenes}
        tags={tags}
        onSelect={this.onSelect}
        materials={materials}
        products={products}
        selected={selected}
        onPageLeave={this.onPageLeave}
        createJob={createJob}
        filterAlphabet={filterAlphabet}
        onChange={this.onChange}
        tag={tag}
        displayType={displayType}
        entitystate={entitystate}
      />
    );
  }
}

const listingPage = catogary =>
  connect(
    state => ({
      catogary: catogary,
      models: getModels(state),
      materials: getMaterials(state),
      scenes: getScenes(state),
      tags: getTags(state),
      products: getProducts(state),
      selected: getSelected(catogary, state),
    }),
    {
      fetchModels,
      fetchScenes,
      fetchMaterials,
      fetchTags,
      setView,
      setSelected,
      fetchProducts,
      createJob,
    }
  )(Listing);

export default listingPage;



// WEBPACK FOOTER //
// ./src/containers/Listing/index.js